import { render, staticRenderFns } from "./card-ecommend.vue?vue&type=template&id=21169588&scoped=true&"
import script from "./card-ecommend.vue?vue&type=script&lang=js&"
export * from "./card-ecommend.vue?vue&type=script&lang=js&"
import style0 from "./card-ecommend.vue?vue&type=style&index=0&id=21169588&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21169588",
  null
  
)

export default component.exports